import { frontendURL } from 'dashboard/helper/URLHelper';
import AssistenteIaLayout from './AssistenteIaLayout.vue';
import ListaDeAssistentes from './pages/ListaDeAssistentes.vue';
import EditarAssistente from './pages/EditarAssistente.vue';
import BaseDeConhecimento from './pages/BaseDeConhecimento.vue';
import Playground from './pages/Playground.vue';
import Credenciais from './pages/Credenciais.vue';
import Caixas from './pages/Caixas.vue';
import Atendimentos from './pages/Atendimentos.vue';
import Consumo from './pages/Consumo.vue';

// Assistente de IA — as telas do módulo.
//
// `permissions: ['administrator']` é repetido em CADA filho de propósito: o router valida a
// rota de destino, e o menu lateral usa a mesma informação para esconder o item de quem não é
// administrador. Um filho sem o `meta` seria uma porta aberta.
const soAdministrador = { permissions: ['administrator'] };

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/assistente-ia'),
      component: AssistenteIaLayout,
      meta: soAdministrador,
      children: [
        {
          path: '',
          name: 'assistente_ia_home',
          component: ListaDeAssistentes,
          meta: soAdministrador,
        },
        {
          path: 'assistentes/:assistenteId',
          name: 'assistente_ia_assistente',
          component: EditarAssistente,
          meta: soAdministrador,
        },
        {
          path: 'assistentes/:assistenteId/base',
          name: 'assistente_ia_base',
          component: BaseDeConhecimento,
          meta: soAdministrador,
        },
        {
          path: 'assistentes/:assistenteId/playground',
          name: 'assistente_ia_playground',
          component: Playground,
          meta: soAdministrador,
        },
        {
          path: 'credenciais',
          name: 'assistente_ia_credenciais',
          component: Credenciais,
          meta: soAdministrador,
        },
        {
          path: 'caixas',
          name: 'assistente_ia_caixas',
          component: Caixas,
          meta: soAdministrador,
        },
        {
          path: 'atendimentos',
          name: 'assistente_ia_atendimentos',
          component: Atendimentos,
          meta: soAdministrador,
        },
        {
          path: 'consumo',
          name: 'assistente_ia_consumo',
          component: Consumo,
          meta: soAdministrador,
        },
      ],
    },
  ],
};
